/** Medical Slim ZERO 専用LP（公式サイト内に仮価格を出さず、料金・プランの詳細はLPへ集約する） */
const SLIM_ZERO_LP_URL = "https://sbscl.biz/zero/";

type SlimZeroLpLinkProps = {
  /** 表示文 */
  note?: string;
  /** CTAラベル */
  label?: string;
  /** 遷移先（未指定時はMedical Slim ZERO専用LP） */
  url?: string;
};

export default function SlimZeroLpLink({
  note = "Medical Slim ZEROの料金・プラン・詳細については専用ページでご確認いただけます。",
  label = "Medical Slim ZEROの料金・詳細を見る",
  url = SLIM_ZERO_LP_URL,
}: SlimZeroLpLinkProps) {
  return (
    <div className="flex flex-col gap-7 border border-foreground-950/12 bg-background-50 p-8 md:flex-row md:items-center md:justify-between md:p-10">
      <div>
        <span className="en-eyebrow text-[10px] text-secondary-700 md:text-[11px]">PRICE / PLAN</span>
        <p className="mt-4 max-w-2xl font-heading text-[16px] leading-[1.9] text-foreground-900 md:text-lg">{note}</p>
      </div>
      <a
        href={url}
        className="group flex w-full max-w-full items-center justify-center gap-2 rounded-md bg-primary-600 px-5 py-3.5 text-[13px] font-medium text-background-50 transition-colors hover:bg-primary-700 sm:gap-3 sm:px-8 sm:text-[14px] md:inline-flex md:w-auto md:shrink-0 md:whitespace-nowrap"
      >
        <span className="min-w-0 leading-snug">{label}</span>
        <i
          className="ri-arrow-right-line shrink-0 transition-transform group-hover:translate-x-1"
          aria-hidden
        />
      </a>
    </div>
  );
}